import React, { useState, useEffect } from "react";
import experienceDetailBG from "assets/images/others/host-side-images/experienceDetailBG.png";
import { ReactComponent as LocationIcon } from "assets/images/svgs/locationDark.svg";
import { ReactComponent as CalandarIcon } from "assets/images/svgs/calendarDark.svg";
import { ReactComponent as ClockIcon } from "assets/images/svgs/clockdark.svg";
import attende1 from "assets/images/others/host-side-images/attende1.png";
import attende2 from "assets/images/others/host-side-images/attende2.png";
import attende3 from "assets/images/others/host-side-images/attende3.png";
import attende4 from "assets/images/others/host-side-images/attende4.png";
import hostImage from "assets/images/others/host-side-images/hostImg.png";
import eventBadge from "assets/images/others/host-side-images/eventBadge.png";
import bgAttendess from "assets/images/others/host-side-images/bgAttendess.png";
import representatives1 from "assets/images/others/host-side-images/representatives1.png";
import representatives2 from "assets/images/others/host-side-images/representatives2.png";
import { useLocation, useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import AttendeeBreadcrumb, {
  AttendeBreadcrumbLink,
} from "components/breadcrumbs/AttendeeBreadcrumb";
import TicketPopup from "components/popups/pass-popup";
import useStore from "hooks/useStore";

interface Attendee {
  id: number;
  profileImage: string;
  title: string;
}

const attendees: Attendee[] = [
  {
    id: 1,
    profileImage: representatives1,
    title: "David Silbia",
  },
  {
    id: 2,
    profileImage: representatives2,
    title: "Jukkoe Sisao",
  },
  {
    id: 3,
    profileImage: representatives1,
    title: "Harriet King",
  },
  {
    id: 4,
    profileImage: representatives2,
    title: "Oliver Robert",
  },
  {
    id: 5,
    profileImage: representatives1,
    title: "Bertha Valdez",
  },
  {
    id: 6,
    profileImage: representatives2,
    title: "Harriet Payne",
  },
  {
    id: 7,
    profileImage: representatives1,
    title: "Lily French",
  },
  {
    id: 8,
    profileImage: representatives2,
    title: "Howard Adkins",
  },
  {
    id: 9,
    profileImage: representatives1,
    title: "Earl Bowman",
  },
];
const AttendeePasses = () => {
  const navigate = useNavigate();
  const { isProfileCompleted } = useStore();
  const breadcrumbLinks: AttendeBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.attendeeHome },
    { title: "Experiences ", path: siteRoutes.attendeeExperiences },

    { title: "Passes", path: siteRoutes.attendeePasses },
  ];

  const [isPassPopupOpen, setIsPassPopupOpen] = useState(false);

  // Check profile completion on mount - redirect to home if not completed
  useEffect(() => {
    const profileCompleted = isProfileCompleted();
    if (!profileCompleted) {
      navigate(siteRoutes.attendeeHome, { replace: true });
    }
  }, [isProfileCompleted, navigate]);

  // get data from state if available
  // const location = useLocation() 
  // const params = location.state.formData;
  // console.log(params);
  
  return (
    <div>
      <div
        style={{ backgroundImage: `url(${experienceDetailBG})` }}
        className="bg-cover bg-center bg-no-repeat h-full md:h-[320px] w-full"
      >
        <div className="h-full host-bg-gradient">
          <div className="container">
            <div className="flex flex-wrap justify-between gap-6 items-center ">
              <AttendeeBreadcrumb links={breadcrumbLinks} />
            </div>

            <div className="flex justify-between flex-wrap items-center gap-6">
              <div className="flex items-center">
                <div className="flex flex-col gap-3">
                  <p className="flex items-center text-base text-lightBlackText">
                    <LocationIcon className="mr-1" /> ABC Avenue, San Francisco
                  </p>
                  <h1 className="text-blackie text-2xl md:3xl lg:text-5xl font-medium ">
                    How to improve your <br /> Communication and Social Life
                  </h1>
                  <div className="flex flex-wrap gap-4 text-base text-lightBlackText">
                    <p className="flex items-center gap-1">
                      <CalandarIcon /> 14 October, 2024
                    </p>
                    <p className="flex items-center gap-1">
                      <ClockIcon /> 12:30 to 02:30
                    </p>
                  </div>
                  <div className="flex flex-wrap gap-6 items-center">
                    <div className="flex items-center ">
                      {[attende1, attende2, attende3, attende4].map(
                        (attende, index) => (
                          <img
                            key={index}
                            className={`w-[30px] h-[30px] object-cover object-center rounded-full border border-white ${
                              index > 0 ? "ml-[-8px]" : ""
                            }`}
                            src={attende}
                            alt={`Attendee ${index + 1}`}
                          />
                        )
                      )}
                      <span className="text-base text-lightBlackText ml-2">
                        15+ attending
                      </span>
                    </div>
                    <div className="flex flex-wrap gap-5 items-center">
                      <button className="bg-yellowText rounded-md text-white px-4 py-2">
                        Workshop
                      </button>
                      <span className="text-2xl text-blackie font-semibold">
                        $120
                      </span>
                      <span className="text-xl text-lightBlackText">
                        0 Slots Available
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="">
                <div className="flex flex-wrap gap-4 ">
                  <div className="flex flex-col items-center justify-center gap-2 rounded-lg w-[193px] h-[217px] bg-white p-3 shadow-md">
                    <img
                      className="w-[126px] h-[126px]"
                      src={eventBadge}
                      alt="Event Badge"
                    />
                    <span className="text-base font-medium">Event Badge</span>
                  </div>

                  <div
                    onClick={() => {
                      navigate(siteRoutes.attendeeHostProfileDetail);
                    }}
                    className="flex flex-col items-center justify-center gap-2 cursor-pointer rounded-lg w-[193px] h-[217px] bg-white p-3 shadow-md"
                  >
                    <img
                      className="w-[103px] h-[103px] rounded-full object-contain"
                      src={hostImage}
                      alt="Host"
                    />
                    <div className="text-center">
                      <p className="font-medium text-lg">Host</p>
                      <p className="font-semibold text-base">Steve Johnson</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container my-5">
        <div className="relative">
          <h3 className="text-blackie text-2xl font-medium mb-2 flex items-center gap-1">
            Ticket Pass
          </h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 py-5">
          {attendees.map((attendee) => (
            <div
              key={attendee.id}
              className="relative flex flex-col items-center justify-center p-6 rounded-lg  transition-all duration-300 border ${
               
              "
              style={{ backgroundImage: `url(${bgAttendess})` }}
            >
              {/* Attendee Image */}
              <img
                className="w-[98px] h-[98px] rounded-full object-cover"
                src={attendee.profileImage}
                alt={attendee.title}
              />

              {/* Attendee Name */}
              <span className="text-lg font-semibold my-3 text-blackie">
                {attendee.title}
              </span>
              <span
                onClick={() => setIsPassPopupOpen(true)}
                className="text-sm cursor-pointer text-yellowText"
              >
                View Pass
              </span>
            </div>
          ))}
        </div>
      </div>
      {isPassPopupOpen && (
        <TicketPopup
          isOpen={isPassPopupOpen}
          onClose={() => setIsPassPopupOpen(false)}
        />
      )}
    </div>
  );
};

export default AttendeePasses;
